module.exports = __webpack_public_path__ + "media/assets/images/blog/the-file-is-corrupt-and-cannot-be-opened-b80087221bdbc0a3756a04bfe24e8080.png";